module.exports = __webpack_public_path__ + "static/img/nbg_platform.29701665.png";